export default __webpack_public_path__ + "static/media/close_icon.3e97eb35.svg";